export const fontConstants = {
  SOURCE_SANS_PRO: "Source Sans Pro",
  ARAIL: "Arial",
  SANS_SERIF: "sans-serif",
  METRIC: "Metric",
  PT_SERIF: "PT Serif",
};
